export enum SUBSCRIPTION_TABLE_COLUMN_ID {
  STATE = 'state',
  REPORT_NAME = 'reportName',
  STATUS = 'status',
  CREATED_DATE = 'createdDate',
  REPORT_LAST_RUN = 'reportLastRun',
  REPORT_NEXT_RUN = 'reportNextRun',
  MANAGER_ACCOUNTS = 'managerAccounts',
  ADVERTISER_ACCOUNTS = 'advertiserAccounts',
  ACCOUNTS = 'accounts',
  FREQUENCY = 'frequency',
  REPORT_PERIOD = 'reportPeriod',
  FILE_FORMAT = 'fileFormat',
  LAST_MODIFIED_DATE = 'lastModifiedDate',
  SCHEDULE_END_DATE = 'scheduleEndDate',
  HISTORY = 'history',
  REPORT_SOURCE = 'reportSource'
}
